"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerTimestampFromFirstoreTimestamp = void 0;
const round_1 = __importDefault(require("lodash/round"));
function integerTimestampFromFirstoreTimestamp(timestamp) {
    return (0, round_1.default)(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
}
exports.integerTimestampFromFirstoreTimestamp = integerTimestampFromFirstoreTimestamp;
